export default "__VITE_ASSET__e38ef46c__"